import { createContext, useContext } from 'react';
import { IProductCalculationsApi } from 'api/digifi/ProductCalculationsApi';
import { IAddressLookupApi } from 'api/digifi/AddressLookupApi';
import { IAdminAuthApi } from 'api/digifi/AdminAuthApi';
import { IRecaptchaApi } from 'api/digifi/RecaptchaApi';
import { ILexisNexisApi } from 'api/digifi/LexisNexisApi';

export interface IApiProviderValue {
  productCalculationsApi: IProductCalculationsApi;
  addressLookupApi: IAddressLookupApi;
  adminAuthApi: IAdminAuthApi;
  recaptchaApi: IRecaptchaApi;
  lexisNexisApi: ILexisNexisApi;
}

export type Services =
  | IProductCalculationsApi
  | IAddressLookupApi
  | IAdminAuthApi
  | ILexisNexisApi
  | IRecaptchaApi;

const ApiContext = createContext<IApiProviderValue>({} as IApiProviderValue);

const getService = <ServiceType extends Services>(serviceName: keyof IApiProviderValue) => () => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const services = useContext(ApiContext);

  return services[serviceName] as ServiceType;
};

export const useProductCalculationsApi = getService<IProductCalculationsApi>('productCalculationsApi');

export const useAddressLookupApi = getService<IAddressLookupApi>('addressLookupApi');

export const useAdminAuthApi = getService<IAdminAuthApi>('adminAuthApi');
export const useRecaptchaApi = getService<IRecaptchaApi>('recaptchaApi');
export const useLexisNexisApi = getService<ILexisNexisApi>('lexisNexisApi');

const ApiProvider = ApiContext.Provider;

export default ApiProvider;
